export default __webpack_public_path__ + "static/media/support.75f9cd07.svg";